import classNames from 'classnames';
import { FC } from 'react';

import { ConditionView } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import { Status } from '../../Status/Status';
import { Truncatable } from '../../Truncatable/Truncatable';
import { Typography } from '../../Typography';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { ComplaintCardProps } from '../model/types';

import { DonwloadAppealButton } from './ActionButtons/DonwloadAppealButton';
import { Row, RowRenderer } from './RowRenderer';

export const ComplaintCard: FC<ComplaintCardProps> = ({
  data: { id, title, requestNumber, createdAt, complainDescription },
  status,
  onDownloadAppeal,
  informerData,
  variant,
}) => {
  const rows: Row[] = [
    {
      label: 'Номер запиту',
      value: requestNumber,
      dataTestId: 'complaint-card-request-number',
    },
    {
      label: 'Дата створення',
      value: formatDate(createdAt),
      dataTestId: 'complaint-card-created-at',
    },
  ];

  const descriptionRow: Row[] = [
    {
      label: 'Опис звернення',
      value: complainDescription,
      dataTestId: 'complaint-card-complain-description',
      isColFull: true,
    },
  ];
  return (
    <BaseCard
      data-testid="complaint-card"
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__header">
          <div data-testid="complaint-card-status" className="service-row-card__status-wrapper">
            <Status status={status} />
          </div>
          <div className="service-row-card__title-wrapper">
            <Truncatable
              text={
                <Typography data-testid="complaint-card-title" variant="H4">
                  {title}
                </Typography>
              }
            />
          </div>
        </div>
      }
      body={
        <div className="service-row-card__body">
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={rows} />
          </div>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={descriptionRow} />
          </div>
        </div>
      }
      informer={informerData}
      actions={[
        <ConditionView key="download-appeal" if={!!onDownloadAppeal}>
          <DonwloadAppealButton
            onClick={(): void =>
              onDownloadAppeal && onDownloadAppeal({ id, title, requestNumber, createdAt, complainDescription })
            }
          />
        </ConditionView>,
      ]}
    />
  );
};
